module.exports = __webpack_public_path__ + "static/media/documentos.a82c681b.svg";